export const gradient = {
  default: "linear-gradient(to right, #08c781, #00bfb3)",
  dark: "linear-gradient(to right, #07b172, #00ada3)",
};
